import React from 'react';
import './Subtotal.css'
import { useStateValue } from './StateProvider';
import CurrencyFormat from 'react-currency-format';
import { getBasketTotal } from './reducer';
import { useEffect } from 'react';
import { useState } from 'react';
import axios from 'axios';

function Subtotal() {
    const [{ basket, deliveryfees }, dispatch] = useStateValue();
    const [options, setOptions] = useState([])
    const [selected, setSelected] = useState(options[0]);

    useEffect(() => {

        if(selected === undefined){
            dispatch({
                type: 'SET_DELIVERYFESS',
                deliveryfees: 0
            })
        }
        else{

            const deliveryPrice = selected.split('- $');
            let priceToInt = parseInt(deliveryPrice[1]);

            dispatch({
                type: 'SET_DELIVERYFESS',
                deliveryfees: priceToInt
            })
        }
    
    }, [selected])

    useEffect(() => {

        axios
            .get('https://toycityzimbabwe.com/backend/getDelivery.php')
            .then(res => {
                
                handleDelivery(res.data)
                
            })
            .catch( error => {
                console.log(error)
            });
    }, [])

    const handleDelivery = (delivery) =>{
        
        setOptions([]);

        delivery.map(item => {
            
            setOptions((prevOptions) =>[
                ...prevOptions,
                [item.dplace + ' - $' + item.dprice]
            ])
        })
    }

    useEffect(() => {
        if(getBasketTotal(basket) < 60){
            document.getElementById("006").style.display = "flex";

            if(selected === undefined){
                dispatch({
                    type: 'SET_DELIVERYFESS',
                    deliveryfees: 0
                })
            }
            else{
    
                const deliveryPrice = selected.split('- $');
                let priceToInt = parseInt(deliveryPrice[1]);
    
                dispatch({
                    type: 'SET_DELIVERYFESS',
                    deliveryfees: priceToInt
                })
            }

        } else{
            document.getElementById("006").style.display = "none";

            dispatch({
                type: 'SET_DELIVERYFESS',
                deliveryfees: 0
            })
        }
    }, [basket])
    
    
    return (
        <div className="subtotal">
            <div className="subtotal__left">
                {/*<div id='006' className='subtotal__deliverystatus'>
                    <input type="checkbox" checked={cdelivery} onChange={() => setCdelivery(toggle)}></input>
                    <label >{deliveryfees}$ Delivery Fees </label> 
                </div>*/}
                <select id='006' 
                    value={selected} 
                    onChange={(e) => setSelected(e.target.value)}>
                        {options.map((value) => (
                        <option value={value} key={value}>
                            {value}
                        </option>
                        ))}
                </select>
            </div>
            <div className="subtotal__right">
                <div className="subtotal__up">
                    <strong>Subtotal </strong>
                    <small> ({basket.length} items)</small>
                </div>
                <div className="subtotal__down">
                    <CurrencyFormat
                        renderText={(value) => (
                            <>
                                <strong>{value}</strong>
                            </>
                        )}
                        decimalScale={2}
                        value={getBasketTotal(basket) + deliveryfees}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                    />
                </div>
            </div>
        </div>
    )
}

export default Subtotal;
